import React from 'react'
import './most_engaged_platform.css'
import { getImgSrc,getPlatformImg } from '../../../../../helpers/getImgSrc'
import { getSvgIcons } from '../../../../../helpers/getReactIcons'

const MostEngagedPlatform = ({ heading = "", card_styles, heading_icon ,most_engaged_platform}) => {
    return (
        <div className="organic_social_connected_accounts_wrapper">
            <div className="organic_social_connected_accounts_wrapper_border" style={{ backgroundColor: card_styles?.card_border_color }}>

            </div>
            <div className="organic_social_connected_accounts_wrapper_top">
                <div className='organic_social_connected_accounts_wrapper_top_heading' >
                    <div className={`organic_social_connected_accounts_wrapper_top_logo ${card_styles?.card_background_color_class}`} >
                        <img src={getImgSrc(heading_icon)} alt="" />
                    </div>
                    <div className='organic_social_connected_accounts_wrapper_top_heading_text'>
                        <h3 className=''>{heading}</h3>
                        <span></span>
                    </div>


                </div>

            </div>
            <div className='organic_social_connected_accounts_wrapper_bottom'>
                <div className="most_engaged_platform_container">
                     <div className="most_engaged_palform_wrapper">
                     <div className="most_engaged_platform_container_logo_container">
                        <div className="most_engaged_platform_container_logo">
                            <img src={getPlatformImg(most_engaged_platform?.platform_id)} alt="" />

                        </div>
                        <div className='most_engaged_platform_container_header'>
                            <h1>{most_engaged_platform?.platform_name}</h1>

                        </div>
                        <div className='most_engaged_platform_container_subheading'>
                            {getSvgIcons('heart', { color: '#f37373' })}
                            <p>{most_engaged_platform?.total_engagement_rate}% Engagement Rate</p>

                        </div>

                    </div>

                    <div className='progress_bar_container'>
                     
                        <div className="progress">
                            <div className="progress-bar" role="progressbar" style={{ width: most_engaged_platform?.total_engagement_rate+'%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>

                    </div>
                    <div className='text_container'>
                        <p>{most_engaged_platform?.platform_name} is your best performing platform with an engagement rate of an {most_engaged_platform?.total_engagement_rate}%.</p>

                    </div>

                     </div>
               

                </div>

            </div>


        </div>
    )
}

export default MostEngagedPlatform